import { call, put, select, } from 'redux-saga/effects';
import {
  SET_LOADING,
  SET_ORDER_DETAILS,
  SET_ORDER_DETAILS_APP,
  SET_ORDERS,
  SET_SAVED_PAYMENTS,
  SET_PROFILE_DETAILS,
  SET_FAQS,
  SET_REFERRAL_LIST_LOADING,
  SET_REFERRAL_LIST,
  orderDetailsSelector,
  SET_INVOICE,
} from './accounts.action';
import {
  getFaqsApi,
  getOrderDetailsApi,
  getOrdersApi,
  putProfileDetailsApi,
  getOrderStatusApi,
  trackOrderApi,
  getReferralListingApi,
  getInvoiceApi,
  postReorderApi,
} from './accounts.api';
import { getPaymentMethodsApi } from '../checkout/checkout.api';
import { SET_NOTIFICATION_MSG_ANIMATE, setAppNotification } from '../../initial.action';
import history from '../../history';
import config from 'appConfig';
import { PAYMENT_GATEWAYS } from '../../util/constantServices';

export function* getOrdersSaga() {

  try {
    yield put({
      type: SET_LOADING,
      data: true
    });
    const { data: orders } = yield call(getOrdersApi);
    yield put({
      type: SET_ORDERS,
      data: {
        onGoingOrders: orders.onGoingOrders,
        pastOrders: orders.pastOrders,
      },
    });
    yield put({
      type: SET_LOADING,
      data: false
    });
  } catch (e) {
    console.log('Err@ getOrdersSaga: ', e);
    yield put({
      type: SET_LOADING,
      data: false
    });
  }
}

export function* getOrderDetailsSaga({ data }) {
  try {
    yield put({ type: SET_LOADING, data: true });
    const { data: orderDetails } = yield call(getOrderDetailsApi, data);
    yield put({
      type: SET_ORDER_DETAILS,
      data: {
        orderDetails,
        orderStatus: {
          orderNo: data.orderNo,
          status: orderDetails.orderStatus,
        },
      },
    });
    yield put({
      type: SET_LOADING,
      data: false
    });
  } catch (e) {
    console.log('Err@ getOrdersSaga: ', e);
    yield put({
      type: SET_LOADING,
      data: false
    });
  }
}

export function* getSavedPaymentsSaga() {
  try {
    yield put({
      type: SET_LOADING,
      data: true
    });
    const { data: savedPayments } = yield call(getPaymentMethodsApi, {});
    const { pgId } = savedPayments;
    let { savedUPIs } = savedPayments;
    if (pgId === PAYMENT_GATEWAYS.PAYU.id) {
      savedUPIs = savedUPIs.map(upi => ({ ...upi, tokenId: Math.random() }));
      savedPayments.savedUPIs = savedUPIs;
    }
    yield put({
      type: SET_SAVED_PAYMENTS,
      data: savedPayments
    });
  } catch (e) {
    console.log('Err@ getSavedPaymentsSaga: ', e);
    yield put({
      type: SET_LOADING,
      data: false
    });
  }
}

export function* putProfileDetailsSaga({ data }) {
  try {
    yield put({
      type: SET_LOADING,
      data: true
    });
    yield call(putProfileDetailsApi, data);
    yield put({
      type: SET_PROFILE_DETAILS,
      data: {
        customerFullName: data.fullName || data.customerFullName, // Mweb may still be using fullName
        email: data?.accountEmail,
      },
    });
    data.successCb && data.successCb();
  } catch (e) {
    console.log('Err@ putProfileDetailsSaga: ', e);
    yield put({
      type: SET_LOADING,
      data: false
    });
    data.failureCb && data.failureCb();
  }
}

export function* getFaqsSaga() {
  try {
    yield put({
      type: SET_LOADING,
      data: true
    });
    const { data: faqs } = yield call(getFaqsApi);
    yield put({
      type: SET_FAQS,
      data: faqs
    });
  } catch (e) {
    console.log('Err@ getFaqsSaga: ', e);
    yield put({
      type: SET_LOADING,
      data: false
    });
  }
}

export function* getOrderStatusSaga({ data }) {
  try {
    const { data: resp } = yield call(getOrderStatusApi, data);
    const orderDetails = yield select(orderDetailsSelector);
    const newOrderDetails = { ...orderDetails };

    // const sampleResp = [
    //   {
    //     "hbOrderTrackingStatus": "ORDER_CONFIRMED",
    //     "orderId": 1016,
    //     "orderNo": "LCMKEW44ABUK4ZS0",
    //     "orderTrackingStatusDate": "24 Jun 2020, 06:37 PM",
    //     "orderTrackingStatusTime": "06:37 PM"
    //   },
    //   {
    //     "hbOrderTrackingStatus": "ORDER_LOGISTICS_DRIVER_ASSIGNED",
    //     "orderId": 1016,
    //     "orderNo": "LCMKEW44ABUK4ZS0",
    //     "orderTrackingStatusDate": "24 Jun 2020, 06:40 PM",
    //     "orderTrackingStatusTime": "06:40 PM"
    //   },
    //   {
    //     "orderId": 999,
    //     "orderNo": "0WDC7J04N9MAJNA0",
    //     "hbOrderTrackingStatus": "ORDER_LOGISTICS_PICKED_UP",
    //     "orderTrackingStatusDate": "24 Jun 2020, 04:09 AM",
    //     "orderTrackingStatusTime": "06:50 AM",
    //     "driverPhoneNo": "1234567890"
    //   }
    // ];
    // console.warn('getOrderStatusSaga', data, resp);

    if (resp?.orderStatus?.length > 0) {
      newOrderDetails.orderStatus = resp?.orderStatus;
    }
    if (resp.status) {
      newOrderDetails.status = resp?.status;
    }
    // newOrderDetails.orderStatus = sampleResp;
    // newOrderDetails.status = 'ORDER_LOGISTICS_PICKED_UP';
    yield put({
      type: SET_ORDER_DETAILS_APP,
      data: newOrderDetails,
    });
    // console.warn('getOrderStatusSaga', resp, newOrderDetails, data);
  } catch (e) {
    console.log('Err@ getOrderStatusSaga: ', e);
  }
}

export function* trackOrderSaga({ data }) {
  try {
    // yield put({ type: SET_LOADING, data: true });
    const { data: orderStatus } = yield call(trackOrderApi, data);
    yield put({
      type: SET_ORDER_DETAILS,
      data: {
        orderStatus: {
          orderNo: data.orderNo,
          status: orderStatus.orderStatus,
        },
      },
    });
  } catch (e) {
    console.log('Err @trackOrderSaga: ', e);
    yield put({ type: SET_LOADING, data: false });
  }
}

export function* getReferralListingSaga() {
  try {
    yield put({
      type: SET_REFERRAL_LIST_LOADING,
      data: true
    });
    const { data: resp } = yield call(getReferralListingApi);
    console.warn('@getReferralListingSaga', resp);

    yield put({
      type: SET_REFERRAL_LIST,
      data: resp,
    });
    yield put({
      type: SET_REFERRAL_LIST_LOADING,
      data: false
    });
  } catch (e) {
    console.log('Err@ getOrdersSaga: ', e);
    yield put({
      type: SET_REFERRAL_LIST_LOADING,
      data: false
    });
  }
}

export function* getInvoiceSaga({ data }) {
  try {
    yield put({ type: SET_LOADING, data: true });
    // console.warn('getInvoiceSaga', data);
    // const sampleInvoiceData = {"action":"success","data":{"companyName":"DZ Fresh Foods Pvt Ltd","companyAddress":"BSEL Tech Park, 7th Floor, B Wing, Opp. Vashi Railway Station, Sector 30A Vashi, Navi Mumbai 400705","companyPhoneNo":"+918080447766","companyEmail":"care@halalbox.in","companyWebSite":"www.halalbox.in","companyGSTin":"27AAFCD8629N1ZO","invoiceNumber":"INV-07/03/22/101427-041","invoiceDate":"03 Jul 2022","customerName":"Yuhanna","customerAddress":"710/ C wing, Golden Soil CHS, Behind Raj Nagar, off S V Road, Jogeshwari West , 101, Gautam Nagar, Jogeshwari West, Mumbai, Maharashtra 400102, India, Opp Heritage Park Bldg, Mumbai Suburban, Maharashtra, India, 400102","customerPhoneNo":"9870973342","invoiceItems":[{"itemName":"Chicken Leg Whole","itemQty":1,"itemRate":170.0,"itemDiscount":0.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":170.0},{"itemName":"Chicken Leg Boneless","itemQty":1,"itemRate":230.0,"itemDiscount":0.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":230.0},{"itemName":"Chicken Drumsticks","itemQty":2,"itemRate":390.0,"itemDiscount":0.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":390.0},{"itemName":"Chicken Biryani Cut - Weekend Special","itemQty":1,"itemRate":315.0,"itemDiscount":16.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":299.0},{"itemName":"Mutton Keema (Mince)","itemQty":1,"itemRate":545.0,"itemDiscount":0.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":545.0},{"itemName":"Chicken Lollipop","itemQty":2,"itemRate":318.0,"itemDiscount":0.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":318.0},{"itemName":"Chicken Curry Cut Large Pack - 2KG","itemQty":1,"itemRate":500.0,"itemDiscount":25.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":0.0,"itemSGSTTaxAmount":0.0,"itemCGSTTaxRate":0.0,"itemCGSTTaxAmount":0.0,"itemTotalAmount":475.0},{"itemName":"Chicken BBQ Wings with Sweet & Spicy Dip","itemQty":1,"itemRate":239.04,"itemDiscount":50.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":2.5,"itemSGSTTaxAmount":4.98,"itemCGSTTaxRate":2.5,"itemCGSTTaxAmount":4.98,"itemTotalAmount":199.0},{"itemName":"Chicken Peri Peri Drumsticks with Garlic Dip","itemQty":1,"itemRate":317.8,"itemDiscount":67.0,"itemPromoDiscount":0.0,"itemSaleDiscount":0.0,"itemReferralAmount":0.0,"itemSGSTTaxRate":2.5,"itemSGSTTaxAmount":6.6,"itemCGSTTaxRate":2.5,"itemCGSTTaxAmount":6.6,"itemTotalAmount":264.0}],"shippingFee":0.0,"discountAmount":158.0,"promotionAmount":0.0,"referralAmount":0.0,"walletAmount":0.0,"subTotalAmount":2866.84,"sgstTaxAmountRate":2.5,"sgstTaxAmount":11.58,"cgstTaxAmountRate":2.5,"cgstTaxAmount":11.58,"totalAmount":2890.0}};
    // const invoiceBody = generateInvoiceBody(sampleInvoiceData.data);
    const { data: resp } = yield call(getInvoiceApi, data);
    const invoiceBody = generateInvoiceBody(resp);
    yield put({ type: SET_INVOICE, data: invoiceBody });
    data.successCb && data.successCb({ invoiceBody });
  } catch (e) {
    console.log('Err@ getInvoiceSage: ', e);
    yield put({ type: SET_LOADING, data: false });
    yield put({
      type: SET_NOTIFICATION_MSG_ANIMATE,
      data: e?.data,
    });
  }
}

export function* postReorderSaga({ data, cb }) {
  try {
    yield put({ type: SET_LOADING, data: true });
    const { data: resp } = yield call(postReorderApi, data);
    console.warn('postReorderSaga', data, resp);
    if(!config.isApp) {
      history.push('/cart?isReorder=true');
    } else {
      cb();
    }
  } catch (e) {
    console.log('Err@ postReorderSaga: ', e);
    yield put({ type: SET_LOADING, data: false });
    yield put({
      type: SET_NOTIFICATION_MSG_ANIMATE,
      data: 'Fail to process reorder.',
    });
  }
}

function generateInvoiceBody(data) {
  const {
    // Company Info
    companyName,
    companyAddress,
    companyEmail,
    companyPhoneNo,
    companyWebSite,
    invoiceDate,
    companyGSTin,
    // Invoice
    invoiceNumber,
    // Customer
    customerName,
    customerPhoneNo,
    customerAddress,
    // Tax Summary
    cgstTaxAmount,
    cgstTaxAmountRate,
    sgstTaxAmount,
    sgstTaxAmountRate,
    shippingFee,
    subTotalAmount,
    totalAmount,
    discountAmount,
    // invoiceItems
    invoiceItems,
  } = data || {};
  const LOGO_URL =
    'https://ik.imagekit.io/iwcam3r8ka/prod/emails/202207/ae9b6545-243a-4012-b6cd-487633fedbe3.jpg';
  const Logo = `
    <div style="">
      <img 
        src="${LOGO_URL}" 
        alt="HALALBOX LOGO" 
        style="
          width: 250px;
          height: 83px;
        "
      />
    </div>
  `;
  const BillTo = `
    <div style="max-width: 250px;">
      <h2>Billing To</h2>
      <p style="line-height:0.5">${customerName}</p>
      <p style="line-height:0.5">${customerPhoneNo}</p>
      <p>${customerAddress}</p>
    </div>`;
  const ItemHeader = `
    <tr style="background-color: #f2f3f8">
      <th style="text-align:center">No.</th>
      <th style="text-align:center">Item</th>
      <th style="text-align:center">Quantity</th>
      <th style="text-align:center">Rate</th>
      <th style="text-align:center">Amount</th>
    </tr>
  `;
  const items = invoiceItems.map((item, i) => {
    return `
      <tr>
          <td style="text-align:center">${i + 1}</td>
          <td style="text-align:center">${item.itemName}</td>
          <td style="text-align:center">${item.itemQty}</td>
          <td style="text-align:center">${item.itemRate}</td>
          <td style="text-align:center">${item.itemTotalAmount}</td>
      </tr>
      `;
  });
  const sellerDetails = `
            <br />
            <br />
            <br />
            <div> Seller Details: 
            <p style="line-height:0.5">${companyName}</p>
            <p style="line-height:0.5">${companyAddress}</p>
            <p style="line-height:0.5">${companyEmail}</p>
            <p style="line-height:0.5">${companyPhoneNo}</p>
            <p style="line-height:0.5">${companyWebSite}</p>
            <p style="line-height:0.5">${invoiceDate}</p>
            <p style="line-height:0.5">${companyGSTin}</p>
            </div>
        `;
  const summary = `
            <div style="display: flex; justify-content: flex-end; background-color: #f2f3f8; margin-top:20px; padding-right: 50px;">
                <br />
                <br />
                <br />
                <div>
                    <p style="line-height:0.5">Sub Total: ₹${subTotalAmount}</p>
                    <p style="line-height:0.5">CGST (${cgstTaxAmountRate}%): ₹${cgstTaxAmount}</p>
                    <p style="line-height:0.5">SGST (${sgstTaxAmountRate}%): ₹${sgstTaxAmount}</p>
                    <p style="line-height:0.5">Shipping Fee: ₹${shippingFee}</p>
                    <p style="line-height:0.5">Discount: ₹${discountAmount}</p>
                    <p style="line-height:0.5">TOTAL: ₹${totalAmount}</p>
                </div>
            </div>
        `;
  const invoiceBody = `
          <style type = "text/css">
            body {font-family:'ProductSans',Lato,'Lucida Grande',Verdana,Tahoma,'sans-serif';}
          </style>
          <div>
            <h1>Invoice: ${invoiceNumber}</h1>
            ${Logo}
            ${BillTo}
            <table style="width: 100%">
            ${ItemHeader}
            ${items}
            </table>
            ${summary}
            ${sellerDetails}
        </div>`;
  return invoiceBody;
}
